// components/MainMenu.tsx
import React from 'react';
import { useClipShare } from '../hooks/useClipShare';
import { useLanguage } from '../context/LanguageContext';

export const MainMenu: React.FC = () => {
  const { setView } = useClipShare();
  const { t } = useLanguage();

  return (
    <div className="main-menu">
      <div className="menu-card" onClick={() => setView('setup')}>
        <span className="menu-icon">⚡</span>
        <div className="menu-title">{t.oneTimeSharing}</div>
        <div className="menu-description">
          {t.oneTimeSharingDesc}
        </div>
      </div>

      <div className="menu-card disabled">
        <span className="menu-icon">👤</span>
        <div className="menu-title">{t.userAccount}</div>
        <div className="menu-description">
          {t.userAccountDesc}<br />
          <small style={{ color: 'var(--warning)' }}>{t.comingSoon}</small>
        </div>
      </div>
    </div>
  );
};